import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const AllLangQual = () => {
    const [langQualifications, setLangQualifications] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchLangQualifications();
    }, []);


    const fetchLangQualifications = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/langQualifications/all');
            const data = await response.json();
            setLangQualifications(data);
        } catch (error) {
            console.error('Error fetching Language Qualifications:', error);
        }
    };

    const handleDelete = async (langQualificationsId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this language qualification?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/langQualifications/delete/${langQualificationsId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        // Update local state after successful deletion
                        const updatedLangQual = langQualifications.filter(langQualifications => langQualifications.id !== langQualificationsId);
                        setLangQualifications(updatedLangQual);
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The language qualification has been deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete language qualification');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the language qualification.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting language qualification:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the language qualification.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter language qualifications based on search term
    const filteredLangQual = langQualifications.filter(qual => 
        (qual.langQualName && qual.langQualName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.university && qual.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.teachingMethod && qual.teachingMethod.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.duration && qual.duration.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.courseFee && qual.courseFee.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.payMethod && qual.payMethod.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.institutePhone && qual.institutePhone.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.instituteEmail && qual.instituteEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.instituteWebsite && qual.instituteWebsite.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (
        <div>
            <AdminDashboard />

            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>ALL LANGUAGE QUALIFICATIONS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table> 
                            <thead>
                                <tr>
                                    <th>Language Exam Name</th>
                                    <th>Institute Name</th>
                                    <th>Teaching Method</th>
                                    <th>Duration</th>
                                    <th>Course Fee</th>
                                    <th>Paying Method</th>
                                    <th>Contact No.</th>
                                    <th>Email</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredLangQual.map((langQualifications) => (
                                    <tr key={langQualifications.id}>
                                        <td>{langQualifications.langQualName}</td>
                                        <td>{langQualifications.university}</td>              
                                        <td>{langQualifications.teachingMethod}</td>
                                        <td>{langQualifications.duration}</td>
                                        <td>{langQualifications.courseFee}</td>              
                                        <td>{langQualifications.payMethod}</td>
                                        <td>{langQualifications.institutePhone}</td>
                                        <td>{langQualifications.instituteEmail}</td>
                                        <td>
                                            <a href={langQualifications.instituteWebsite} target="_blank" rel="noopener noreferrer">
                                                Visit Website
                                            </a>
                                        </td>
                                        <td id='action-buttons'>
                                            {/* <a href="#!" id='man-details' onClick={() => handleEdit(course.id)}>EDIT</a> */}
                                            <a href="#!" id='del-details' onClick={() => handleDelete(langQualifications.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllLangQual;
